import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'

import { cn } from '@eigtech/ui/lib/utils'

function AspectRatio({
  ratio = 1,
  render,
  className,
  ...props
}: useRender.ComponentProps<'div'> & { ratio?: number }) {
  const divEl = useRender({
    defaultTagName: 'div',
    render,
    props: mergeProps<'div'>(
      {
        className: cn('absolute inset-0', className),
      },
      props
    ),
  })

  return (
    <div
      data-slot="aspect-ratio"
      style={{
        // ensures inner element is contained
        position: 'relative',
        // ensures padding bottom trick maths works
        width: '100%',
        paddingBottom: `${100 / ratio}%`,
      }}
    >
      {divEl}
    </div>
  )
}

export { AspectRatio }
